// Services
import { mapgisSeg } from "../services/mapgisSeg";

export const iniciarSesion = async ({
  userName: id_Persona,
  password,
  idApp: app,
}) => {
  try {
    const response = await mapgisSeg("validacion.do", {
      id_Persona,
      password,
      app,
    });

    return {
      login: response,
    };
  } catch (err) {
    throw err;
  }
};
